module.exports = __webpack_public_path__ + "img/to_enlarge.7c684980.svg";